export const PRODUCT_CLASSES = [
  'Beer',
  'Cheese',
  'Chocolate',
  'Cider',
  'Cigar',
  'Coffee',
  'Confectionary',
  'Energy Drink',
  'Flavors',
  'Hop',
  'Malt',
  'Milk',
  'Noodles',
  'Sake',
  'Soda',
  'Spirit',
  'Tea',
  'Water',
  'Wine',
  'Other'
];

export const PRODUCT_ATTRIBUTES = [
  'alcohol_by_volume',
  'ibu',
  'brand',
  'brewery',
  'application',
  'flavor',
  'brand',
  'base',
  'dosage',
  'IPC/Experimental'
];

export const ALLERGEN_ATTRIBUTES = {
  CONTAINS: [
    'No Allergens',
    'Eggs',
    'Fish',
    'Nuts',
    'Peanut',
    'Soybeans',
    'Shellfish',
    'Wheat',
    'Seeds',
    'Dairy',
    'Lupin',
    'Milk (Including Lactose)',
    'Molluscs',
    'Mustard',
    'Sesame Seeds',
    'Sulphur Dioxide And Sulphites',
    'Celery',
    'Cereals Containing Gluten',
    'Crustaceans'
  ],
  SAFE: ['Gluten-Free', 'Nut-Free', 'Kosher', 'Halal', 'Vegan', 'Vegetarian']
};

export const ALL_ALLERGENS = ALLERGEN_ATTRIBUTES.CONTAINS.slice(
  1,
  ALLERGEN_ATTRIBUTES.CONTAINS.length
);

// Allergen pairs: selecting one auto-selects its pair(s), deselecting removes pair(s)
export const ALLERGEN_PAIRS = {
  'Shellfish': ['Crustaceans', 'Molluscs'],
  'Crustaceans': ['Shellfish'],
  'Molluscs': ['Shellfish'],
  'Wheat': ['Cereals Containing Gluten'],
  'Cereals Containing Gluten': ['Wheat'],
  'Seeds': ['Sesame Seeds'],
  'Sesame Seeds': ['Seeds'],
  'Dairy': ['Milk (Including Lactose)'],
  'Milk (Including Lactose)': ['Dairy']
};

// Sync paired allergens on selection change
export const syncAllergenSelection = (newValue, oldValue = []) => {
  if (!newValue) return newValue;
  if (!Array.isArray(newValue)) return newValue; // Return unexpected values as-is
  const val = (v) => v?.value || v?.label;
  const prev = new Set((Array.isArray(oldValue) ? oldValue : []).map(val));
  const curr = new Set(newValue.map(val));

  // Add pairs of newly added items
  curr.forEach((n) => !prev.has(n) && ALLERGEN_PAIRS[n]?.forEach((p) => curr.add(p)));

  // Remove pairs of deselected items (cascade: removing A removes A's pairs, then their pairs)
  let changed = true;
  while (changed) {
    changed = false;
    prev.forEach((n) => {
      if (!curr.has(n)) ALLERGEN_PAIRS[n]?.forEach((p) => { if (curr.delete(p)) changed = true; });
    });
  }

  return [...curr].map((n) => ({ value: n, label: n }));
};

export const SERVING_VESSEL = [
  'Can',
  'Ceramic Cup',
  'Plastic Cup',
  'Plate',
  'Bowl',
  'Pouch',
  'Glass',
  'Wine Glass',
  'Tulip Glass',
  'Flute Glass',
  'Thermos',
  'Others'
];

export const PHYSICAL_STATE = [
  'Solid',
  'Semi-Solid',
  'Liquid',
  'Carbonated Liquid',
  'Gas',
  'Frozen',
  'Others'
];
